import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_fiat_header",
  "use": "icon-ic_fiat_header-usage",
  "viewBox": "0 0 44 45",
  "content": "<symbol viewBox=\"0 0 44 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_fiat_header\">\r\n<circle cx=\"22\" cy=\"22.5\" r=\"22\" fill=\"url(#icon-ic_fiat_header_paint0_linear_7718_1111)\" />\r\n<defs>\r\n<linearGradient id=\"icon-ic_fiat_header_paint0_linear_7718_1111\" x1=\"0\" y1=\"22.5\" x2=\"44\" y2=\"22.5\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"#3771E2\" />\r\n<stop offset=\"1\" stop-color=\"#134CBC\" />\r\n</linearGradient>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol